<template>
  <div>
    <div class="box box-primary">
      <div class="box-header">
        <h3 class="box-title" style="text-transform: capitalize;">{{$t('coupons.title')}}</h3>
      </div>
      <div class="box-body">
        <div class="row pull-right">
          <div class="col-md-12">
            <button
              class="btn btn-info btn-sm extra-tools pull-right"
              @click="onOpenAddCouponInput"
            >
              <i class="glyphicon glyphicon-plus"></i>
              Add
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 table-responsive no-padding">
            <b-table :items="serviceCouponsItems" :fields="coupons_fields" class="mt-3" outlined>
              <template #head()="scope">
                <div>{{ $t(scope.label) }}</div>
              </template>
              <template slot="actions" slot-scope="row">
                <div class="btn-group">
                  <button
                    type="button"
                    class="btn btn-danger dropdown-toggle"
                    data-toggle="dropdown"
                    aria-expanded="true"
                  >
                    <i class="fa fa-fw fa-ellipsis-h"></i>
                  </button>
                  <ul class="dropdown-menu" style="min-width: 50px;height: 80px;">
                    <li>
                      <button
                        class="btn btn-primary btn-sm"
                        style="margin-left: 6px;"
                        @click="onOpenEditCouponInput(row)"
                      >
                        <i class="glyphicon glyphicon-edit"></i>
                      </button>
                    </li>
                    <li>
                      <button
                        class="btn btn-danger btn-sm"
                        style="margin-left: 6px;"
                        @click="onOpenDeleteCouponInput(row)"
                      >
                        <i class="glyphicon glyphicon-trash"></i>
                      </button>
                    </li>
                  </ul>
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="box-footer"></div>
    </div>
    <!-- Modal Coupon Input -->
    <div class="modal fade" :ref="`modal-coupons-input`">
      <div class="modal-dialog modal-lg">
        <ServiceCouponsModalInput
          :id="object_data.id"
          @coupon-add="onAdd"
          @coupon-save="onSave"
        />
      </div>
    </div>
    <!-- Modal Confirm Delete -->
    <div class="modal fade" :ref="`modal-customer-coupons-delete`">
      <div class="modal-dialog">
        <Confirm :id="object_data.id" @confirm="onDeleteCoupon" />
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ServiceCouponsModalInput from "./ServiceCouponsModalInput";
import Confirm from "@/components/Confirm.vue";
import utils from "@/lib/utils";
// import Loading from "vue-loading-overlay"
// import i18n from '../../lang'
import constantsData from "@/lib/constantsData";

export default {
  name: "ServiceCouponsList",
  props: {
    id: {
      type: Number,
      default: () => {
        return 0;
      }
    }
  },
  data() {
    return {
      object_data: {
        id: 0
      },
      coupons_fields: [
        {
          key: "nonumber",
          label: "common.nonumber",
          sortable: true,
          class: "text-center"
        },
        {
          key: "code",
          label: "coupons.code",
          sortable: true,
          class: "text-center"
        },
        {
          key: "name",
          label: "coupons.name",
          sortable: false,
          class: "text-center"
        },
        {
          key: "notes",
          label: "coupons.notes",
          sortable: false,
          class: "text-center"
        },
        {
          key: "discount",
          label: "coupons.discount",
          sortable: false,
          class: "text-center"
        },
        {
          key: "number_coupons",
          label: "coupons.number_coupons",
          sortable: true,
          class: "text-center"
        },
        {
          key: "expires_at",
          label: "coupons.expires_at",
          sortable: true,
          class: "text-center"
        },
        {
          key: "status",
          label: "coupons.status",
          sortable: true,
          class: "text-center"
        },
        { key: "actions", label: "common.action", sortable: true }
      ],
      serviceCouponsItems: []
    };
  },
  watch: {
    // id: function() {
    //   if (this.id !== 0) {
    //     this.getCouponsList();
    //   } else {
    //     // pass
    //   }
    // },
    COUPONS_LIST: function() {
      let serviceCouponsItems = [];
      let nonumber = 0;
      this.COUPONS_LIST.forEach((coupons, i) => {
        nonumber += 1;
        let id = coupons.id;
        let code = coupons.code;
        let name = coupons.name;
        let notes = coupons.notes;
        let number_coupons = coupons.number_coupons;
        // 1: discount_amount
        // 2: discount_percentage
        let discount =
          coupons.coupon_type_code == 'cash'
            ? utils.floatFormat(coupons.discount_amount)
            : coupons.discount_percentage + "%";
        let coupon_type_code = coupons.coupon_type_code;
        let expires_at = utils.formatSqlDate(coupons.expires_at, null, constantsData.dateOptionList[0].format, "");

        // let status = this.$t("servicecouponstatus.status[" + coupons.status + "]");
        let status = coupons.status

        let item = {
          id: id,
          nonumber: nonumber,
          code: code,
          name: name,
          notes: notes,
          discount: discount,
          number_coupons: number_coupons,
          coupon_type_code: coupon_type_code,
          expires_at: expires_at,
          status: status
        };
        serviceCouponsItems.push(item);
      });
      this.serviceCouponsItems = serviceCouponsItems;
      this.$emit("serviceCouponsItems", this.serviceCouponsItems);
    }
  },
  computed: {
    ...mapGetters([
      "COUPONS_LIST"
    ])
  },
  methods: {
    ...mapActions([
      "GET_COUPONS_LIST",
      "ADD_COUPON",
      "UPDATE_COUPON",
      "DELETE_COUPON",
      // "GET_CARDS_LIST"
    ]),
    getGender: function(gender) {
      if (gender == 1) {
        return this.$t(`customer.gender_type[0]`);
      }
      if (gender == 2) {
        return this.$t(`customer.gender_type[1]`);
      }
      if (gender == 3) {
        return this.$t(`customer.gender_type[2]`);
      }
    },
    onToggleModalInput: function(action = "show") {
      $(this.$refs[`modal-coupons-input`]).modal(action);
    },
    onToggleDeleteConfirm: function(action = "show") {
      $(this.$refs[`modal-customer-coupons-delete`]).modal(action);
    },
    getCouponsList: function(data) {
      const payload = {
        params: {
          page: 1
        }
      };
      this.GET_COUPONS_LIST(payload);
    },
    onAdd: function(data) {
      const payload = {
        data: data
      };
      this.ADD_COUPON(payload).then(
        function(res) {
          this.onToggleModalInput("hide");
          this.getCouponsList();
        }.bind(this)
      );
    },
    onSave: function(id, data) {
      const payload = {
        id: id,
        data: data
      };
      this.UPDATE_COUPON(payload).then(
        function(res) {
          this.onToggleModalInput("hide");
          this.getCouponsList();
          this.getCardsList();
        }.bind(this)
      );
    },
    onOpenAddCouponInput: function() {
      this.object_data.id = 0;
      this.onToggleModalInput();
    },
    onOpenEditCouponInput: function(row) {
      this.object_data.id = row.item.id;
      this.onToggleModalInput();
    },
    onOpenDeleteCouponInput: function(row) {
      this.object_data.id = row.item.id;
      this.onToggleDeleteConfirm();
    },
    onDeleteCoupon: function(id) {
      const payload = {
        id: id
      };
      this.DELETE_COUPON(payload).then(
        function() {
          this.onToggleDeleteConfirm("hide");
          this.getCouponsList();
        }.bind(this)
      );
    }
  },
  mounted() {
    this.getCouponsList();
  },
  components: {
    ServiceCouponsModalInput,
    Confirm
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Service/ServiceCouponsList.vue